// Docs: https://www.contentful.com/developers/docs/references/images-api/

import type { ContentfulImagesAPI } from '@lib/types'
import type { ImageLoaderProps } from 'next/image'

type ContentfulLoaderProps = Omit<Partial<ImageLoaderProps>, 'quality'>
export default function createContentfulLoader(outerLoaderProps: ContentfulImagesAPI) {
  // src and width get passed in from the <Image> element props
  return ({ src, width }: ContentfulLoaderProps) => {
    const validUrlString = 'https:' + src
    const url = new URL(validUrlString)

    if (width) {
      url.searchParams.set('w', width.toString())
    }

    Object.entries(outerLoaderProps).forEach(([key, val]) => {
      switch (key) {
        case 'r':
          url.searchParams.set(key, val.toString())
          break
        case 'q':
          url.searchParams.set('q', val.toString() || '75')
          break
        default:
          if (key && val) {
            url.searchParams.set(key, val)
          }
          break
      }
    })
    return url.href
  }
}
